MeshGroup.bind = function (group, mesh) {
    Utils.inheritMethods(group, new MeshGroup());

    console.log("Mesh Group binding", group);

    group.bind(mesh);

    console.log("Mesh Group bound");

    return group;
};

function MeshGroup() {
    /**
     *
     */
    MeshGroup.prototype.bind = function (mesh, superGroup) {
        this.class = "MeshGroup";
        this.__mesh = mesh;
        this.__superGroup = superGroup;

        if (!this.subGroups) {
            this.subGroups = [];
        }

        for (var n in this.subGroups) {
            Utils.inheritMethods(this.subGroups[n], new MeshGroup());

            this.subGroups[n].bind(mesh, this);
        }

        this.__devices = [];

        for (var n in this.devices) {
            console.log("Get Device ", this.devices[n], mesh);
            var device = mesh.getDeviceByPath(this.devices[n]);

            console.log('result', device);

            this.__devices.push(device);
            device.__inGroup = true;
        }

        this.__actors = [];

        //for (var n in this.actors) {
        //    var path = this.actors[n].split(".");
        //
        //    this.__actors.push(mesh.getDeviceByPath(path[0]).getActor(
        //        path[1]));
        //}

        this.__sensors = [];

        //for (var n in this.sensors) {
        //    var path = this.sensors[n].split(".");
        //
        //    this.__sensors.push(node.getDevice(path[0]).getSensor(
        //        path[1]));
        //}

        if (!this.services) {
            this.services = [];
        }

        this.__services = [];

        //for (n in this.services) {
        //    this.__services.push(node.getService(this.services[n]));
        //}
    };

    /**
     *
     */
    MeshGroup.prototype.path = function () {
        return !this.__superGroup ? this.id : this.__superGroup.path() + "." + this.id;
    };

    /**
     *
     */
    MeshGroup.prototype.getSubGroup = function (id) {
        for (var n in this.subGroups) {
            if (this.subGroups[n].id == id) {
                return this.subGroups[n];
            }
        }

        throw "No Subgroup with id [" + id + "]";
    };

    /**
     *
     */
    MeshGroup.prototype.replaceSubGroup = function (group) {
        for (var n in this.subGroups) {
            if (this.subGroups[n].id == group.id) {
                this.subGroups[n] = group;

                return;
            }
        }

        throw "No Subgroup with id [" + group.id + "]";
    };

    /**
     *
     */
    MeshGroup.prototype.getAllGroups = function () {
        var groups = [];

        for (var n in this.subGroups) {
            groups.push.apply(groups, this.subGroups[n]
                .getAllGroups());
            groups.push(this.subGroups[n]);
        }

        return groups;
    };

    /**
     *
     */
    MeshGroup.prototype.containsSensor = function (sensor) {
        for (var n in this.sensors) {
            if (this.sensors[n] === sensor.fullId()) {
                return true;
            }
        }

        for (var n in this.subGroups) {
            if (this.subGroups[n].containsSensor(sensor)) {
                return true;
            }
        }

        return false;
    };

    /**
     *
     */
    MeshGroup.prototype.getDevices = function () {
        return this.__devices;
    };

    /**
     *
     */
    MeshGroup.prototype.getSensors = function () {
        return this.__sensors;
    };

    /**
     *
     */
    MeshGroup.prototype.containsActor = function (actor) {
        for (var n in this.actors) {
            if (this.actors[n] === actor.fullId()) {
                return true;
            }
        }

        for (var n = 0; n < this.subGroups.length; ++n) {
            if (this.subGroups[n].containsActor(actor)) {
                return true;
            }
        }

        return false;
    };

    /**
     *
     */
    MeshGroup.prototype.getActors = function () {
        return this.__actors;
    };
}
